import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#00C57F",
      d: "M7 10.5a.7.7 0 0 0 .7-.7V7a.7.7 0 1 0-1.4 0v2.8a.7.7 0 0 0 .7.7m-.644-6.034a.5.5 0 0 0 .063.126l.084.105a.7.7 0 0 0 .763.147.8.8 0 0 0 .231-.147.7.7 0 0 0 .147-.763.63.63 0 0 0-.378-.378.66.66 0 0 0-.532 0 .63.63 0 0 0-.378.378.7.7 0 0 0-.056.266 1 1 0 0 0 0 .14q.018.067.056.126M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14M7 1.4a5.6 5.6 0 1 1 0 11.2A5.6 5.6 0 0 1 7 1.4"
    }, null, -1)
  ]))]))
}
export default { render: render }